import { Link } from "@tanstack/react-router";
import { type LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { NotificationPopover } from "@/components/shared/navigation/notification-popover";
import { cn } from "@/lib/utils";

interface HeaderUtilityAction {
  labelKey: string;
  icon?: LucideIcon;
  imageSrc?: string;
  imageAlt: string;
  imageClassName?: string;
  to?: "/ai";
}

const HEADER_UTILITY_ACTIONS: readonly HeaderUtilityAction[] = [
  {
    labelKey: "common:nav.openAiAssistant",
    imageSrc: "/icons/header/help.svg",
    imageAlt: "",
    imageClassName: "h-5 w-5",
    to: "/ai",
  },
];

export function HeaderUtilityActions() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-1">
      {HEADER_UTILITY_ACTIONS.map(
        ({ labelKey, icon: Icon, imageSrc, imageAlt, imageClassName, to }) => {
          const content = (
            <>
              {imageSrc ? (
                <img src={imageSrc} alt={imageAlt} className={imageClassName} />
              ) : null}
              {Icon ? (
                <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.75} />
              ) : null}
            </>
          );
          const className = cn(
            "flex items-center justify-center rounded-full text-nav-text transition-colors",
            "hover:bg-nav-item-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            Icon ? "h-7 w-7" : "h-8 w-8 lg:h-10 lg:w-10",
          );
          return to ? (
            <Link key={labelKey} to={to} aria-label={t(labelKey)} className={className}>
              {content}
            </Link>
          ) : (
            <button
              key={labelKey}
              type="button"
              aria-label={t(labelKey)}
              className={className}
            >
              {content}
            </button>
          );
        },
      )}
      <NotificationPopover />
    </div>
  );
}
